module.exports = __webpack_public_path__ + "media/Instruction_68.aa0f5d58.mp3";